import { motion, useMotionValue } from "framer-motion";
import { useEffect } from "react";
import { BOT_NAME, DEFAULT_GRID_RESOLUTION, DEFAULT_SPRING } from "../consts";
import { colorValue } from "../css/color";
import { useUserInfo } from "../liveblocks/maps";
import { styled } from "../stitches.config";
import { Presence } from "../types";

const borderWidth = 0;

export default function ViewportRect({
  isSelf,
  userId,
  viewport,
}: {
  isSelf: boolean;
  userId: string;
  viewport?: Presence["viewport"];
}) {
  const [userInfo] = useUserInfo(userId);

  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const w = useMotionValue(0);
  const h = useMotionValue(0);

  useEffect(() => {
    if (viewport) {
      const { position, size } = viewport;

      x.set(position.x - borderWidth / 2);
      y.set(position.y - borderWidth / 2);
      w.set(size.width + borderWidth);
      h.set(size.height + borderWidth);
    }
  }, [viewport, x, y, w, h]);

  if (!userInfo) return <></>;

  const position = {
    x: x,
    y: y,
  };
  const size = {
    width: w,
    height: h,
  };
  if (isSelf) return null;
  if (userInfo.name === BOT_NAME) return null;

  const color = colorValue(userInfo.color, 80, 0.1);

  return (
    <ViewPortOutline
      className="viewport"
      key={userInfo.id}
      style={{
        borderColor: color || "transparent",
        ...position,
        ...size,
      }}
      transition={DEFAULT_SPRING}
    ></ViewPortOutline>
  );
}

export const ViewPortOutline = styled(motion.div, {
  position: "absolute",
  pointerEvents: "none",
  top: 0,
  left: 0,
  fontSize: "$3",
  borderWidth: DEFAULT_GRID_RESOLUTION,
  borderStyle: "solid",
});
